import React, { useState, useEffect } from "react";
import api from "../../common/lib/api";

import Managed, { useManaged } from "../../common/components/Managed";
import moment from "moment";
import { shortenAtlasId } from "../shortenAtlasId";
import DialogButton from "../../common/components/DialogButton";
import {
  Dialog,
  Classes,
  Button,
  EditableText,
  Label,
  InputGroup,
} from "@blueprintjs/core";

import { DatePicker } from "@blueprintjs/datetime";
import { extractSingleError } from "../../common/components/Errors";

export default function Page() {
  const [state, setState, setError] = useManaged();

  useEffect(() => {
    api.get("/vpn").then((x) => setState(x.data.data), setError);
  }, [setState, setError]);

  console.log(state);

  return (
    <>
      <Managed state={state}>
        <h1>Managed VPN Billing</h1>
        {Object.entries(state.data || {}).map(([system, data]) => (
          <>
            <table className="bp3-html-table bp3-html-table-bordered bp3-html-table-striped">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Status</th>
                  <th>#</th>
                  <th>Start</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.map((vpn) => (
                    <VpnRow key={vpn.id} system={system} vpn={vpn} />
                  ))}
              </tbody>
            </table>

            <DialogButton
              intent="primary"
              system={system}
              dialog={VPNAddDialog}
              onClose={(e) => {
                window.location.reload();
              }}
            >
              New
            </DialogButton>
          </>
        ))}
      </Managed>
    </>
  );
}

function VpnRow({ system, vpn }) {
  return (
    <tr>
      <td>
        <h3>
          {vpn.companyName}
          {vpn.title ? ` - ${vpn.title}` : ""}
        </h3>
        {shortenAtlasId(vpn.companyId, true)}
      </td>
      <td>{vpn.status}</td>
      <td>{vpn.subscriptions}</td>
      <td>{moment(vpn.subscriptionDate).format("llll")}</td>
      <td>
        {vpn.status === "active" && (
          <DialogButton
            intent="primary"
            dialog={VPNChangeDialog}
            system={system}
            vpnId={vpn.id}
            onClose={(e) => {
              window.location.reload();
            }}
          >
            Edit
          </DialogButton>
        )}
      </td>
    </tr>
  );
}

function VPNChangeDialog({ system, vpnId, onClose, onChange }) {
  const [vpn, setVpn, setError] = useManaged();
  useEffect(() => {
    api
      .get(`/vpn/${system}/${vpnId}`)
      .then((x) => setVpn(x.data.data), setError);
  }, [setError, setVpn, system, vpnId]);

  const data = vpn.data;

  function update(data, field, name) {
    return {
      defaultValue: data[field],
      onConfirm: (value) => {
        if (data && data[field] !== value) {
          (async () => {
            // eslint-disable-next-line no-restricted-globals
            if (confirm(`Change ${name || field} to ${value}?`)) {
              try {
                await api.put(`/vpn/${system}/${vpnId}`, { [field]: value });
                alert("done");
              } catch (e) {
                setError(e);
              }
            }
          })();
        }
      },
    };
  }

  return (
    <Dialog isOpen onClose={onClose} title="VPN Subscription">
      <div className={Classes.DIALOG_BODY}>
        <Managed state={vpn}>
          {data && (
            <>
              <p>
                Title: <EditableText {...update(data, "title")} />
              </p>
              <p>
                Contact Name: <EditableText {...update(data, "contactName")} />
              </p>
              <p>
                Contact Email:{" "}
                <EditableText {...update(data, "contactEmail")} />
              </p>
              <p>
                Contact Phone:{" "}
                <EditableText {...update(data, "contactNumber")} />
              </p>
              <p>Subscription count:</p>
              <table className="bp3-html-table">
                <thead>
                  <tr>
                    <th>Period</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  {data.counts.map((row) => {
                    return (
                      <tr key={row.period}>
                        <th>{row.period}</th>
                        <th>
                          {row.current ? (
                            <EditableText isEditing {...update(row, "count")} />
                          ) : (
                            row.count
                          )}
                        </th>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </Managed>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>
    </Dialog>
  );
}

function VPNAddDialog({ system, onClose }) {
  const [companies, setCompanies, setError] = useManaged();
  const [state, setState] = useState({
    companyId: "au-control_room-12",
    contactName: "",
    contactEmail: "",
    contactNumber: "",
    subscriptionDate: new Date(),
  });

  useEffect(() => {
    api.get(`/vpn/${system}/companies`).then((x) => {
      const data = x.data.data;
      data
        .sort((a, b) => {
          a = a.companyName.toLowerCase();
          b = b.companyName.toLowerCase();
          if (a > b) {
            return 1;
          }
          return -1;
        })
        .forEach((company) => {
          company.name = `${company.companyName} (${shortenAtlasId(
            company.companyId,
            true
          )})`;
        });
      setCompanies(data);
    }, setError);
  }, [setCompanies, setError, system]);

  function form(field) {
    return {
      value: state[field],
      onChange: (e) => {
        let value = e;
        if (e && e.target) {
          value = e.target.value;
        }
        setState((st) => ({ ...st, [field]: value }));
      },
    };
  }

  async function submit() {
    try {
      await api.post(`/vpn/${system}`, state);
      alert("done");
      onClose();
    } catch (e) {
      alert(extractSingleError(e));
    }
  }

  return (
    <Dialog isOpen onClose={onClose} title="New VPN Subscription">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        {companies.data && (
          <Managed state={companies}>
            <div className={Classes.DIALOG_BODY}>
              <Label>
                Title: <InputGroup {...form("title")} />
              </Label>
              <Label>
                Company
                <div className="bp3-select bp3-fill">
                  <select {...form("companyId")} required>
                    {companies.data.map((company) => (
                      <option key={company.companyId} value={company.companyId}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>
              </Label>
              <Label>
                Contact Name: <InputGroup {...form("contactName")} required />
              </Label>
              <Label>
                Contact Email:{" "}
                <InputGroup {...form("contactEmail")} required type="email" />
              </Label>
              <Label>
                Contact Phone:{" "}
                <InputGroup {...form("contactNumber")} type="tel" />
              </Label>
              <Label>Subscription Date:</Label>
              <div>
                <DatePicker
                  timePrecision="second"
                  {...form("subscriptionDate")}
                  required
                />
              </div>
            </div>
          </Managed>
        )}
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={onClose}>Close</Button>
            <Button type="submit" intent="primary">
              Add
            </Button>
          </div>
        </div>
      </form>
    </Dialog>
  );
}
